









































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import ExpansionPanel from "../ui/ExpansionPanel.vue";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import moment from "moment";
import { ContractsModule } from "@/store/contracts.module";
import { TableReportsService } from "@/services/api/tableReports.service";
import { groupBy, isObjectEmpty } from "@/utils";

@Component({
  components: {
    ExpansionPanel,
    MonthPicker,
  },
})
export default class ElectricityReport extends Mixins(
  ContractIdValidatorMixin,
) {
  period = {
    from: "2021-01-01",
    to: "",
    max: "",
  };
  loading = false;
  rows = [];
  generalInfo: any = {};

  get contractDate() {
    return moment(this.generalInfo.contract_date).format("DD.MM.YYYY");
  }
  get issuedDate() {
    return moment().format("DD.MM.YYYY HH:mm");
  }

  get userFullname() {
    const user = this.$store.state.auth.user;
    return `${user.last_name} ${user.first_name} ${user.middle_name}`;
  }

  headersValues: any = {
    pointNumber: "account_point_number2",
    pointName: "account_point_name2",
    meterNumber: "meter_number2",
    indicationsBegin: "indication_date_begin3",
    indicationsEnd: "indication_date_end3",
    indicationsDiff: "indications_diff2",
    transformCoef: "transform_coef2",
    consumptionMeter: "consumption_meter3",
    consumptionCalc: "consumption_calc3",
    consumptionDop: "consumption_Dop2",
    consumptionSPM: "consumption_SPM2",
    consumptionLost: "consumption_lost2",
    consumptionSub: "consumption_sub3",
    consumptionRecalc: "consumption_recalc3",
    consumptionOperation: "consumption_operation2",
  };

  contractSums: any = [
    "consumption_meter",
    "consumption_calc",
    "consumption_Dop",
    "consumption_SPM",
    "consumption_lost",
    "consumption_sub",
    "consumption_recalc",
    "consumption_operation",
  ];

  tableItems: Record<number | string, any> = {};

  async mounted() {
    const today = new Date();
    const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    this.period.to = moment(prevMonth).format("YYYY-MM");
    this.period.max = moment(prevMonth).format("YYYY-MM");
  }

  async showButtonHandleClick() {
    this.loading = true;
    this.tableItems = {};
    const contractRid = ContractsModule.selectedContract;
    const data = (
      await TableReportsService.get402Form(
        Number(contractRid),
        `${this.period.to}-01`,
      )
    ).data;
    this.generalInfo = data.generalInfo;
    this.rows = data.res;
    this.makeObj();
    this.loading = false;
  }

  get headers() {
    // const cols: any = this.$t("electricityReport.tableHeaders");
    const colsLocales: any[] = [];

    const cols: any = {
      pointNumber: "ЕН коды/Код ТУ",
      pointName: "ЕН атауы/Наименование ТУ",
      meterNumber:
        "Есептегіштің нөмірі/Тарифтік аймақ/Номер счетчика/Тарифная зона",
      indicationsBegin:
        "Қезең басындағы көрсеткіштер/Показания на начало периода",
      indicationsEnd: "Қезең соңындағы көрсеткіштер/Показания на конец периода",
      indicationsDiff: "Көрсеткіштердің айырмасы/Разность показаний",
      transformCoef: "Есеп. Коэф./Расч. коэф.",
      consumptionMeter: "ЕҚ бойынша шығын, кВт.с/Расход по ПУ, кВт.ч",
      consumptionCalc: "ЕҚ-сыз бойынша шығын, кВт.с/Расход без ПУ, кВт.ч",
      consumptionDop: "Қосымша шығын, кВт.с/Доп. расход, кВт.ч",
      consumptionSPM: "ЖҚҚ, кВт.с/СПМ, кВт.ч",
      consumptionLost: "шығындар, кВт.с/Потери, кВт.ч",
      consumptionSub: "Қосалқы абоненттер, кВт.с/Субабоненты, кВт.ч",
      consumptionRecalc: "Қайта есептеу, кВт.с/Перерасчет, кВт.ч",
      consumptionOperation: "Тұтыну, кВт.с/Потребление, кВт.ч",
    };

    Object.keys(cols).forEach(item => {
      colsLocales.push({
        text: cols[item],
        value: this.headersValues[item],
      });
    });

    return colsLocales;
  }

  makeObj() {
    const table2: any[] = this.rows.filter((obj: any) => obj.table_id === 2);
    const table3: any[] = this.rows.filter((obj: any) => obj.table_id === 3);
    const tempItems: object[] = [];
    for (let i = 0; i < table2.length; i++) {
      const subData = table3.find(
        (item: any) => item.record_id3 === table2[i].record_id2,
      );
      tempItems.push(Object.assign(table2[i], subData));
    }

    this.tableItems = groupBy(tempItems, "object_supplier_rid2");
  }

  get consumptionSums() {
    const sums: Record<number | string, any> = {};
    Object.keys(this.tableItems).forEach((key: number | string) => {
      sums[key] = this.tableItems[key].reduce(
        (sum: number, group: Record<string, any>) =>
          sum + group.consumption_operation2 ? group.consumption_operation2 : 0,
        0,
      );
    });
    return sums;
  }

  get noTableItems() {
    return isObjectEmpty(this.tableItems);
  }

  print() {
    const form402: any = document.querySelector(`#form402`);
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";

    iframe.onload = () => {
      const iwindow = iframe.contentWindow as Window;

      // удаление iframe из DOM-а после закрытия модального окна печати (независимо от результата)
      iwindow.onafterprint = function() {
        iframe.remove();
      };

      const doc: any = iframe.contentDocument;
      iwindow.document.body.innerHTML = form402.outerHTML;

      // Добавление стилей
      doc.body.innerHTML =
        doc.body.innerHTML +
        `<style>
            * {
              color: #222;
              font-size: 12px;
            }

            table {
              border-collapse: collapse
            }

            table th {
              text-align: center;
            }

            table th,
            table tr:not(.contract-sum-row) td {
             border: 1px solid #222;
            }

            th, td {
              padding: 0.3em;
              font-size: 12px
            }

            table tr td.group-sum-cell {
              border-width: 2px;
            }

            .text-right {
              text-align: right;
            }

            .d-flex {
              display: flex;
            }

            .flex-column {
              flex-direction: column;
            }

            .align-self-center {
              align-self: center;
            }

            .justify-space-between {
              justify-content: space-between;
            }
          </style>`;

      iwindow.print();
    };
    document.body.appendChild(iframe);
  }
}
